import React, { useState, useEffect, useRef } from "react";
import { useWeb3ModalAccount, useWeb3Modal } from "@web3modal/ethers/react";
import { Home, ShoppingBag, User, Mail, Info, Rss, Menu } from "lucide-react";

export default function Navbar({ setActiveSection }) {
  const [activeButton, setActiveButton] = useState("Buy IHKAAS");
  const [visible, setVisible] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false); // Mobile menu state
  const lastScrollY = useRef(0);
  const { open } = useWeb3Modal();
  const { isConnected, address } = useWeb3ModalAccount();

  const handleClick = (section) => {
    setActiveButton(section);
    setActiveSection(section);
    setMenuOpen(false); // Close menu on selection (for mobile)
  };

  useEffect(() => {
    const controlNavbar = () => {
      if (window.scrollY > lastScrollY.current) setVisible(false);
      else setVisible(true);
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", controlNavbar);
    return () => window.removeEventListener("scroll", controlNavbar);
  }, []);




  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const timeoutIdRef = useRef(null);

  const handleMouseEnter = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutIdRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 100); // 5 seconds delay
  };
  return (
    <div className={`fixed top-0 left-0 w-full p-4 z-50 bg-black text-white flex flex-col items-center transition-transform duration-300 ${visible ? "translate-y-0" : "-translate-y-full"}`}>
      <div className="flex justify-between w-full items-center border-b border-[#e1c780] pb-2">
      <div className="flex justify-center md:justify-start w-full md:w-auto">
  <img src="/Logo-600x300-2.webp" alt="Logo" className="h-[83px] w-auto" />
</div>






        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-4 mr-4 items-center">
          <a href="https://ihkaas.io/" className="text-white hover:text-[#e1c780] flex items-center">
            <Home size={20} className="mr-1" /> IHKAAS.io
          </a>
          <div className="relative group" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <a href="/" className="text-white hover:text-[#e1c780] flex items-center">
              <ShoppingBag size={20} className="mr-1" /> Shops ▼
            </a>
            <div className={`absolute ${isDropdownOpen ? 'flex' : 'hidden'} flex-col bg-black border border-[#e1c780] mt-2 py-2 rounded shadow-lg w-48 transition-opacity duration-300`}>
            {[
                { label: "IHKAAS Crypto", url: "https://ihkaas.io/crypto", target: "_blank" },
                { label: "NFT Marketplace", url: "https://ihkaas.io/nft", target: "_blank" },
                { label: "Shop", url: "https://ihkaas.io/shop", target: "_blank" },
                { label: "Web Design", url: "https://ihkaas.io/webdesign", target: "_blank" },
                { label: "Product Design", url: "https://ihkaas.io/contacts/", target: "_blank" },
              ].map((item) => (
                <a 
                  key={item.label} 
                  href={item.url} 
                  className="px-4 py-2 text-white hover:text-[#e1c780] hover:bg-gray-800"
                  target={item.target}
                  rel="noopener noreferrer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {["Buy IHKAAS",  "Leaderboard","Tokenomics", "Roadmap", "Whitepaper","Help", ].map((section) => (
            <button
              key={section}
              className={` py-2 font-medium rounded transition hover:text-[#e1c780] ${activeButton === section ? "text-[#e1c780] border-b-2 border-[#e1c780]" : "text-white"}`}
              onClick={() => handleClick(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          ))}
        <button onClick={isConnected ? () => open("Account") : () => open("Connect")} className="px-3 py-2 font-medium text-[15px]  text-black rounded hover:bg-[#efff5e]"
         style={{ backgroundColor: '#efc75e', transition: 'background-color 0.3s' }}   >
            {isConnected ? `${address.substring(0, 4)}...${address.slice(-4)}` : "CONNECT WALLET"}
          </button>
          <div className="flex space-x-2 mt-2">
            <a href="https://ihkaas.io/blog/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
              <Rss className="hover:text-[#e1c780] cursor-pointer mb-1" />
          
            </a>
            <a href="https://ihkaas.io/about-us/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
              <User className="hover:text-[#e1c780] cursor-pointer mb-1" />
           
            </a>
            <a href="https://ihkaas.io/contacts/" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
              <Mail className="hover:text-[#e1c780] cursor-pointer mb-1" />
            
            </a>
          </div>
        </div>

        {/* Mobile Menu Toggle Button (Sticky) */}
     
      </div>
      <div className="flex justify-between items-center w-full md:hidden mt-2 px-1 border-b border-[#e1c780]">
  {/* Left Section - Icons & Connect Wallet */}
  <div className="flex items-center gap-4 flex-wrap">
    {[
      { label: "Blog", url: "https://ihkaas.io/blog/", icon: <Rss size={22} /> },
      { label: "About", url: "https://ihkaas.io/about-us/", icon: <User size={22} /> },
      { label: "Contact", url: "https://ihkaas.io/contacts/", icon: <Mail size={22} /> },
    ].map((item) => (
      <a 
        key={item.label} 
        href={item.url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="px-2 py-1 text-white hover:text-[#e1c780] hover:bg-gray-800 flex flex-col items-center text-xs"
      >
        {item.icon}
        <span className="mt-1">{item.label}</span>
      </a>
    ))}

    {/* 🟢 Wallet Connect Button */}
    <button 
      onClick={isConnected ? () => open("Account") : () => open("Connect")} 
      className="px-2 py-2 text-black rounded-md text-xs font-medium hover:bg-[#e1c780] transition"
      style={{ backgroundColor: '#e1c780' }}
    >
      {isConnected ? `${address.substring(0, 4)}...${address.slice(-4)}` : "CONNECT WALLET"}
    </button>
  </div>

  {/* Right Section - Menu Toggle */}
  <button className="text-white ml-2" onClick={() => setMenuOpen(!menuOpen)}>
    <Menu size={26} />
  </button>
</div>


      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden flex flex-col items-center bg-[#1a1a1a] w-full p-4 border-t border-gray-600">
          <div className="flex flex-col w-full text-center">

          <a 
    href="https://ihkaas.io/" 
    className="py-3 w-full font-medium border-b border-gray-600 text-white hover:text-[#e1c780] flex justify-center items-center"
  >
    <Home size={20} className="mr-2" /> IHKAAS.io
  </a>







          
                    {/* Shop Dropdown */}
                    <div className="relative w-full">
              <button className="py-3 w-full font-medium border-b border-gray-600 hover:text-[#e1c780]" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
              IHKAAS Shops <span className="ml-2 text-[#e1c780]">▼</span>
              </button>
              {isDropdownOpen && (
                <div className="flex flex-col bg-black border border-[#e1c780] mt-1 py-2 rounded shadow-lg w-full">
                  {[
                    { label: "IHKAAS Crypto", url: "https://ihkaas.io/crypto" },
                    { label: "NFT Marketplace", url: "https://ihkaas.io/nft" },
                    { label: "Shop", url: "https://ihkaas.io/shop" },
                    { label: "Web Design", url: "https://ihkaas.io/webdesign" },
                    { label: "Product Design", url: "https://ihkaas.io/contacts/" },
                  ].map((subItem) => (
                    <a key={subItem.label} href={subItem.url} className="px-4 py-2 text-white hover:text-[#e1c780] hover:bg-gray-800 text-center">
                      {subItem.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
            {["Buy IHKAAS", "Leaderboard", "Tokenomics", "Roadmap", "Whitepaper", "Help"].map((section) => (
              <button
                key={section}
                className={`py-3 w-full font-medium border-b border-gray-600 hover:text-[#e1c780] ${
                  activeButton === section ? "text-[#e1c780] border-b-2 border-[#e1c780]" : "text-white"
                }`}
                onClick={() => handleClick(section)}
              >
                {section}
              </button>
            ))}

    
          </div>
        </div>
      )}


    </div>
  );
}
